import React from "react";
import { ArrowRight } from "lucide-react";
import { heroImage, trustedLogos } from "../mock/mock";

const Hero = () => {
  const go = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  const ticker = [...trustedLogos, ...trustedLogos, ...trustedLogos];

  return (
    <section id="top" className="relative bg-[#0A0A0A] text-[#F4F1EA] pt-36 pb-0 overflow-hidden">
      {/* giant ghost infinity */}
      <svg className="absolute -right-24 top-10 w-[620px] opacity-[0.06] spin-slow hidden md:block" viewBox="0 0 52 30" fill="none">
        <path d="M9 15C9 9 15 9 19 15C23 21 29 21 33 15C37 9 43 9 43 15C43 21 37 21 33 15C29 9 23 9 19 15C15 21 9 21 9 15Z" stroke="#F4F1EA" strokeWidth="1.4" fill="none" />
      </svg>

      <div className="container-x grid lg:grid-cols-12 gap-12 items-center pb-20 relative">
        <div className="lg:col-span-7 fade-up">
          <p className="eyebrow text-[#F4F1EA]/60 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-[#F4F1EA]/60" /> One in a Billion — Digital Engineering
          </p>
          <h1 className="mt-6 display font-extrabold uppercase leading-[0.9] tracking-tight text-[clamp(2.4rem,4.6vw,4.3rem)] relative z-10">
            Accelerate<br />Your Business<br />With <span className="hl-invert">AI</span> Solutions
          </h1>
          <p className="mt-8 text-[#F4F1EA]/70 text-lg max-w-xl leading-relaxed">
            Next-gen AI, elite global talent, and expert engineering. Infinity Solutions helps you build
            smarter, scale faster, and lead digital transformation — relentlessly.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <button onClick={() => go("#contact")} className="btn-paper group">
              Speak to an Architect <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button onClick={() => go("#services")} className="btn-outline-paper">Explore Services</button>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg border-t-2 border-[#F4F1EA]/20 pt-6">
            {[["650+", "Engineers"], ["300+", "Projects"], ["30+", "Industries"]].map(([n, l]) => (
              <div key={l}>
                <p className="display text-3xl font-extrabold">{n}</p>
                <p className="mono text-[11px] uppercase tracking-widest text-[#F4F1EA]/55 mt-1">{l}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 fade-up">
          <div className="relative border-2 border-[#F4F1EA] shadow-[10px_10px_0_#F4F1EA]">
            <img src={heroImage} alt="Digital transformation" className="w-full h-[440px] object-cover bw" />
            <div className="absolute -bottom-5 -left-5 bg-[#F4F1EA] text-[#0A0A0A] border-2 border-[#0A0A0A] px-5 py-3">
              <p className="mono text-[11px] uppercase tracking-widest">Trusted by</p>
              <p className="display font-extrabold text-xl">Fortune 250</p>
            </div>
          </div>
        </div>
      </div>

      {/* trusted ticker */}
      <div className="border-t-2 border-[#F4F1EA]/25 marquee-pause overflow-hidden">
        <div className="flex items-center gap-12 w-max animate-marquee py-5">
          {ticker.map((n, i) => (
            <span key={i} className="mono uppercase tracking-widest text-sm text-[#F4F1EA]/50 flex items-center gap-12 whitespace-nowrap">
              {n} <span className="text-[#F4F1EA]/30">✕</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
